/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/Gender",
  isInvalid,
  onChange
  
}) {
  let isMedia = useIsMedia()
let gendersGendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
path: 'genders',
})
let profilePatientPersonGenderValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person.gender',
})
let profilePatientPersonGenderIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'person.gender',
validate: fromValidate.text,
required: true,
})
let profilePatientPersonGenderChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.gender',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={dtSpaceS}
 size={isMedia.mobile ? "small" : "medium"}
 data="genders.genders"
 from={gendersGendersValueData}
 data="profile_patient.person.gender"
 validate="/Data/validate.js text"
 required={true}
 invalid={!profilePatientPersonGenderIsValidData}
 value={profilePatientPersonGenderValueData}
 onChange={profilePatientPersonGenderChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Gender"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
 tabIndex={5}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}